import React from 'react';
import {
    PayCircleOutline,
    CheckCircleOutline,
    CloseCircleOutline,
    FilterOutline
} from 'antd-mobile-icons';
import { PageContainer, PageHeader, PageSection } from '@/components/layout/PageContainer';

interface Transaction {
    id: string;
    title: string;
    amount: string;
    time: string;
    status: 'success' | 'pending' | 'failed';
    type: 'in' | 'out';
}

const mockTransactions: Transaction[] = [
    { id: '1', title: 'USDT 充值', amount: '+1000.00', time: '2023-12-10 14:30', status: 'success', type: 'in' },
    { id: '2', title: '转账给 Alice', amount: '-50.00', time: '2023-12-09 09:15', status: 'success', type: 'out' },
    { id: '3', title: 'ETH 购买', amount: '-200.00', time: '2023-12-08 18:20', status: 'pending', type: 'out' },
    { id: '4', title: '理财收益发放', amount: '+5.23', time: '2023-12-08 00:00', status: 'success', type: 'in' },
    { id: '5', title: '提现失败退回', amount: '+100.00', time: '2023-12-05 10:00', status: 'failed', type: 'in' },
];

export const BillsPage: React.FC = () => {
    return (
        <PageContainer>
            <PageHeader
                title="账单明细"
                right={<FilterOutline fontSize={24} />}
            />

            <PageSection>
                <div className="flex justify-between items-start glass rounded-2xl p-4">
                    <div>
                        <div className="text-sm text-gray-400 mb-1">本月支出 (USDT)</div>
                        <div className="text-2xl font-bold text-red-400">-250.00</div>
                    </div>
                    <div className="text-right">
                        <div className="text-sm text-gray-400 mb-1">本月收入 (USDT)</div>
                        <div className="text-2xl font-bold text-green-400">+1,105.23</div>
                    </div>
                </div>
            </PageSection>

            <PageSection>
                <div className="space-y-4">
                    {mockTransactions.map((tx) => (
                        <div key={tx.id} className="flex items-start gap-3">
                            {/* Timeline Dot */}
                            <div className="flex flex-col items-center shrink-0">
                                <div className={`w-3 h-3 rounded-full ${tx.status === 'success' ? 'bg-green-500' :
                                        tx.status === 'pending' ? 'bg-yellow-500' :
                                            'bg-red-500'
                                    }`} />
                                {tx.id !== '5' && <div className="w-0.5 h-12 bg-white/10 mt-2" />}
                            </div>

                            {/* Content */}
                            <div className="flex-1">
                                <div className="flex justify-between items-start mb-1">
                                    <span className="font-medium">{tx.title}</span>
                                    <span className={`font-bold ${tx.type === 'in' ? 'text-green-400' : 'text-gray-300'
                                        }`}>
                                        {tx.amount}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-500">{tx.time}</span>
                                    <span className={`flex items-center gap-1 ${tx.status === 'success' ? 'text-green-400' :
                                            tx.status === 'pending' ? 'text-yellow-400' :
                                                'text-red-400'
                                        }`}>
                                        {tx.status === 'success' && <><CheckCircleOutline fontSize={14} /> 成功</>}
                                        {tx.status === 'pending' && <><PayCircleOutline fontSize={14} /> 处理中</>}
                                        {tx.status === 'failed' && <><CloseCircleOutline fontSize={14} /> 失败</>}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </PageSection>
        </PageContainer>
    );
};
